import $ from 'jQuery';
import Immutable from 'Immutable';
import CreateDocumentControl from './CreateDocument/CreateDocumentControl';
import SingleEditDocumentControl from './SingleEditDocument/SingleEditDocumentControl';
import BulkEditDocumentsControl from './BulkEditDocuments/BulkEditDocumentsControl';

/**
 * Configurator for Metadata logic controls.
 *
 * @author Pavel Homolka
 */
export default class MetadataLogicConfigurator
{
  /** @type {Array} */
  static createDcumentsControlPool = [];

  /** @type {Array} */
  static singleEditDocumentControlPool = [];

  /** @type {Array} */
  static bulkEditDocumentsControlPool = [];

  /**
   * Inits all CreateDocumentControls
   */
  /*
  static createDocumentControlsInit()
  {
    $('.createDocumentControl').each(function()
    {
      var insertFormId = $(this).data('insertformid');
      var changeURL = $(this).data('changeurl');
      var jsClass = $(this).data('jsclass');
      var userLanguage = $(this).data('userlanguage');
      var stateList = Immutable.fromJS($(this).data('statelist'));

      var control = new CreateDocumentControl(insertFormId, changeURL, jsClass, stateList, userLanguage);
      control.init();
    });
  }
  */

  /**
   * Inits all CreateDocumentControls
   */
  static createDocumentControlsInit()
  {
    $('.createDocumentControl').each(function()
    {
      var control = null;
      var id = $(this).parent().attr('id');

      MetadataLogicConfigurator.createDcumentsControlPool.forEach(function(item)
      {
        if(item.id === id)
        {
          control = item.obj;
          return false;
        }
      });

      if(control == null)
      {
        var insertFormId = $(this).data('insertformid');
        var changeURL = $(this).data('changeurl');
        var jsClass = $(this).data('jsclass');
        var userLanguage = $(this).data('userlanguage');
        var datetimeFormat = $(this).data('datetimeformat');
        var stateList = Immutable.fromJS($(this).data('statelist'));
       
        var control = new CreateDocumentControl(insertFormId, changeURL, jsClass, stateList, userLanguage, datetimeFormat);
        control.init();
        MetadataLogicConfigurator.createDcumentsControlPool.push({id: id, obj: control})
      }
    });
  }


  /**
   * Inits all SingleEditDocumentControls
   */
  static singleEditDocumentControlsInit()
  {
    $('.singleEditDocumentControl').each(function()
    {
      
      var control = null;
      var id = $(this).parent().attr('id');

      MetadataLogicConfigurator.singleEditDocumentControlPool.forEach(function(item)
      {
        if(item.id === id)
        {
          control = item.obj;
          return false;
        }
      });

      if(control == null)
      {
        var insertFormId = $(this).data('editformid');
        var changeURL = $(this).data('changeurl');
        var jsClass = $(this).data('jsclass');
        var userLanguage = $(this).data('userlanguage');
        var submitBtnId = $(this).data('submitbtnid');
        var stateList = Immutable.fromJS($(this).data('statelist'));
        var initialCaption = $(this).data('initialcaption');
        var submitBtnLabel = $(this).data('submitbtnlabel');

        var control = new SingleEditDocumentControl(insertFormId, changeURL, jsClass, stateList, userLanguage, submitBtnId, initialCaption, submitBtnLabel);
        control.init();
        MetadataLogicConfigurator.singleEditDocumentControlPool.push({id: id, obj: control});
      }
    });
  }

  /**
   * Inits all BulkEditDocumentsControls
   */
  static bulkEditDocumentsControlsInit()
  {
    $('.bulkEditDocumentsControl').each(function()
    {
      var control = null;
      var id = $(this).parent().attr('id');

      MetadataLogicConfigurator.bulkEditDocumentsControlPool.forEach(function(item)
      {
        if(item.id === id)
        {
          control = item.obj;
          return false;
        }
      });

      if(control == null)
      {
        var simpleEditFormId = $(this).data('simpleeditformid');
        var advancedEditFormId = $(this).data('advancededitformid');
        var changeURL = $(this).data('changeurl');
        var jsClass = $(this).data('jsclass');
        var stateList = Immutable.fromJS($(this).data('statelist'));

        var control = new BulkEditDocumentsControl(simpleEditFormId, advancedEditFormId, changeURL, jsClass, stateList)
        control.init();
        MetadataLogicConfigurator.bulkEditDocumentsControlPool.push({id: id, obj: control})
      }
    });
  }
};



// WEBPACK FOOTER //
// ./client-side/MetadataLogic/MetadataLogicConfigurator.js